import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';


function Header({setAuthToken, appUserName, setAppUserName, addedGoods, notificationsCount}) {

  addedGoods = addedGoods ? addedGoods : [];
  notificationsCount = Number.isFinite(notificationsCount) && notificationsCount > 0 ? notificationsCount : 0;

  function UserLogout() {
    localStorage.removeItem('authToken');
    localStorage.removeItem('username');
    setAuthToken(null);
    setAppUserName(null);
  }

  function ShoppingCartRedDot({addedGoods}) {

    let goodsNumber = false;
    if (addedGoods.length > 0) { 
      goodsNumber = addedGoods.length;
    }
    return goodsNumber ? (
      <>
        <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" fill="white" className="mx-1 bi bi-cart4" viewBox="0 0 16 16">
          <path d="M0 2.5A.5.5 0 0 1 .5 2H2a.5.5 0 0 1 .485.379L2.89 4H14.5a.5.5 0 0 1 .485.621l-1.5 6A.5.5 0 0 1 13 11H4a.5.5 0 0 1-.485-.379L1.61 3H.5a.5.5 0 0 1-.5-.5M3.14 5l.5 2H5V5zM6 5v2h2V5zm3 0v2h2V5zm3 0v2h1.36l.5-2zm1.11 3H12v2h.61zM11 8H9v2h2zM8 8H6v2h2zM5 8H3.89l.5 2H5zm0 5a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-2 1a2 2 0 1 1 4 0 2 2 0 0 1-4 0m9-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-2 1a2 2 0 1 1 4 0 2 2 0 0 1-4 0"/>
        </svg>
        <svg height="40" width="20" xmlns="http://www.w3.org/2000/svg">
          <circle r="10" cx="10" cy="10" fill="rgb(255, 59, 59)" />
          <text x="50%" y="25%" textAnchor="middle"  fill="rgb(255, 255, 255)" dy=".3em">{goodsNumber}</text>
        </svg> 
      </>
    ) : (
      <>
        <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" fill="white" className="mx-1 bi bi-cart4" viewBox="0 0 16 16">
        <path d="M0 2.5A.5.5 0 0 1 .5 2H2a.5.5 0 0 1 .485.379L2.89 4H14.5a.5.5 0 0 1 .485.621l-1.5 6A.5.5 0 0 1 13 11H4a.5.5 0 0 1-.485-.379L1.61 3H.5a.5.5 0 0 1-.5-.5M3.14 5l.5 2H5V5zM6 5v2h2V5zm3 0v2h2V5zm3 0v2h1.36l.5-2zm1.11 3H12v2h.61zM11 8H9v2h2zM8 8H6v2h2zM5 8H3.89l.5 2H5zm0 5a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-2 1a2 2 0 1 1 4 0 2 2 0 0 1-4 0m9-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-2 1a2 2 0 1 1 4 0 2 2 0 0 1-4 0"/>
        </svg>
      </>
    );
  }

  function NotificationRedDot({notificationsCount}) {
    return notificationsCount ? (
      <>
        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="white" className="mx-1 mt-1 bi bi-bell" viewBox="0 0 16 16">
          <path d="M8 16a2 2 0 0 0 2-2H6a2 2 0 0 0 2 2"/>
          <path d="M8 1.918a1 1 0 0 0-.9.55 5 5 0 0 0-2.7 4.58c0 1.48-.5 2.52-1.13 3.2-.26.28-.53.51-.75.68-.11.08-.2.15-.27.2l-.08.05A.5.5 0 0 0 2.5 12h11a.5.5 0 0 0 .23-.93l-.08-.05a4 4 0 0 1-.27-.2 4.7 4.7 0 0 1-.75-.68c-.63-.68-1.13-1.72-1.13-3.2a5 5 0 0 0-2.7-4.58 1 1 0 0 0-.9-.55M14.22 12c.25 0 .48-.11.64-.29a1.03 1.03 0 0 0 .14-1.2l-.05-.07-.15-.1a4.7 4.7 0 0 1-.25-.19 3.7 3.7 0 0 1-.6-.55c-.47-.52-.95-1.35-.95-2.87a6 6 0 0 0-3.25-5.43A2 2 0 0 0 8 0a2 2 0 0 0-1.75 1.05A6 6 0 0 0 3 6.73c0 1.52-.48 2.35-.95 2.87-.2.22-.42.4-.6.55a4.7 4.7 0 0 1-.25.19l-.15.1A1.03 1.03 0 0 0 1.4 12c.16.18.39.29.64.29z"/>
        </svg>
        <svg height="40" width="20" xmlns="http://www.w3.org/2000/svg">
          <circle r="10" cx="10" cy="10" fill="rgb(255, 59, 59)" />
          <text x="50%" y="25%" textAnchor="middle" fill="rgb(255, 255, 255)" dy=".3em">{notificationsCount}</text>
        </svg>
      </>
    ) : (
      <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="white" className="mx-1 mt-1 bi bi-bell" viewBox="0 0 16 16">
        <path d="M8 16a2 2 0 0 0 2-2H6a2 2 0 0 0 2 2"/>
        <path d="M8 1.918a1 1 0 0 0-.9.55 5 5 0 0 0-2.7 4.58c0 1.48-.5 2.52-1.13 3.2-.26.28-.53.51-.75.68-.11.08-.2.15-.27.2l-.08.05A.5.5 0 0 0 2.5 12h11a.5.5 0 0 0 .23-.93l-.08-.05a4 4 0 0 1-.27-.2 4.7 4.7 0 0 1-.75-.68c-.63-.68-1.13-1.72-1.13-3.2a5 5 0 0 0-2.7-4.58 1 1 0 0 0-.9-.55M14.22 12c.25 0 .48-.11.64-.29a1.03 1.03 0 0 0 .14-1.2l-.05-.07-.15-.1a4.7 4.7 0 0 1-.25-.19 3.7 3.7 0 0 1-.6-.55c-.47-.52-.95-1.35-.95-2.87a6 6 0 0 0-3.25-5.43A2 2 0 0 0 8 0a2 2 0 0 0-1.75 1.05A6 6 0 0 0 3 6.73c0 1.52-.48 2.35-.95 2.87-.2.22-.42.4-.6.55a4.7 4.7 0 0 1-.25.19l-.15.1A1.03 1.03 0 0 0 1.4 12c.16.18.39.29.64.29z"/>
      </svg>
    );
  }

  return(
    <nav className="navbar navbar-dark bg-opacity-75 bg-gradient fixed-top fsvok2" >
      <div className="container-fluid px-5">
        <a className="navbar-brand lk-navbar-link" href="/">ФСВОК | личный кабинет участника МСИ</a>
        <div className="">
          <Link className="lk-navbar-link" to={`/documents/shopping_cart`}>
            <ShoppingCartRedDot
              addedGoods={addedGoods}
            />
          </Link>
          <Link className="lk-navbar-link ms-3" to={`notifications`}>
            <NotificationRedDot
              notificationsCount={notificationsCount}
            />
          </Link>          
          <Link className="lk-navbar-link" to={`profile`}>
            <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" fill="white" className="mx-3 bi bi-person-gear" viewBox="0 0 16 16">
              <path d="M11 5a3 3 0 1 1-6 0 3 3 0 0 1 6 0M8 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4m.256 7a4.5 4.5 0 0 1-.229-1.004H3c.001-.246.154-.986.832-1.664C4.484 10.68 5.711 10 8 10q.39 0 .74.025c.226-.341.496-.65.804-.918Q8.844 9.002 8 9c-5 0-6 3-6 4s1 1 1 1zm3.63-4.54c.18-.613 1.048-.613 1.229 0l.043.148a.64.64 0 0 0 .921.382l.136-.074c.561-.306 1.175.308.87.869l-.075.136a.64.64 0 0 0 .382.92l.149.045c.612.18.612 1.048 0 1.229l-.15.043a.64.64 0 0 0-.38.921l.074.136c.305.561-.309 1.175-.87.87l-.136-.075a.64.64 0 0 0-.92.382l-.045.149c-.18.612-1.048.612-1.229 0l-.043-.15a.64.64 0 0 0-.921-.38l-.136.074c-.561.305-1.175-.309-.87-.87l.075-.136a.64.64 0 0 0-.382-.92l-.148-.045c-.613-.18-.613-1.048 0-1.229l.148-.043a.64.64 0 0 0 .382-.921l-.074-.136c-.306-.561.308-1.175.869-.87l.136.075a.64.64 0 0 0 .92-.382zM14 12.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0"></path>
            </svg>
          </Link>
          <span className="navbar-text ml-5"> Пользователь: {appUserName} <button className="mx-1 lk-button" onClick={UserLogout}>Выход</button></span>
        </div>
      </div>
    </nav>
  );
}

Header.propTypes = {
  setAuthToken: PropTypes.func.isRequired,
  notificationsCount: PropTypes.number
};

export default Header